"use client";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_hooks/hooks";
import { ICMS } from "../home/homeModel";
import { createLookupObject } from "../../_helper/helper";
import { getAllCMSByURL, getAllMetaData } from "../home/services/home.services";
import { Preloader } from "../../components/Preloader";
import { motion } from "motion/react";

import { setCMSList, setMetaDetails } from "../home/homeSlice";

const TermsAndConditions = ({
  initialCMS,
  initialMeta,
}: {
  initialCMS?: any[];
  initialMeta?: any;
}) => {
  const dispatch = useAppDispatch();
  const storeCMSList = useAppSelector((state) => state.home.CMSList);
  const homeLoading = useAppSelector((state) => state.home.loading);
  const MetaDetails = useAppSelector((state) => state.home.MetaDetails);
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, ICMS>>({});

  const CMSList =
    storeCMSList && storeCMSList.length > 0 ? storeCMSList : initialCMS;

  useEffect(() => {
    if (CMSList && CMSList?.length > 0) {
      setLookUpCMSData(createLookupObject(CMSList, "Name"));
    }
  }, [CMSList]);

  useEffect(() => {
    // Hydrate CMS
    if (initialCMS && (!storeCMSList || storeCMSList.length === 0)) {
      dispatch(setCMSList(initialCMS));
    } else if (!storeCMSList || storeCMSList.length === 0) {
      dispatch(getAllCMSByURL("hotel-policy-booking-conditions"));
    }

    // Hydrate Meta
    if (initialMeta) {
      dispatch(setMetaDetails(initialMeta));
    } else {
      dispatch(
        getAllMetaData({
          PageURL: "hotel-policy-booking-conditions",
        }),
      );
    }
  }, [dispatch, initialCMS, initialMeta, storeCMSList]);

  const banner: any =
    BannerList?.find(
      (banner) => banner?.BannerType === "hotel-policy-booking-conditions",
    ) || [];

  return (
    <>
      {homeLoading && <Preloader />}
      <div className="min-h-screen bg-white text-md">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-end justify-center overflow-hidden">
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url('${banner?.BannerImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 mt-25 mb-15">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {banner?.SubTitle && (
                <div className="inline-block px-6 py-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-8">
                  <p className="text-[#C9A962] tracking-[0.4em] text-sm">
                    {banner?.SubTitle || "Hotel Policy & Booking Conditions"}
                  </p>
                </div>
              )}

              <h1 className="text-white text-3xl md:text-4xl lg:text-5xl mb-8 leading-tight max-w-5xl mx-auto font-playfair">
                {/* We Don't Just Build Resorts
                <br /> */}
                <span className="text-[#C9A962]">
                  {banner?.BannerTitle ||
                    "Know the Guidelines That Govern Our Services"}
                  {/* We Craft Experiences */}
                </span>
              </h1>

              {banner?.Description && (
                <p
                  className="text-white/95 text-xl md:text-2xl max-w-3xl mx-auto font-playfair"
                  dangerouslySetInnerHTML={{
                    __html: banner?.Description || "",
                  }}
                />
              )}
            </motion.div>
          </div>
        </section>
        <section className="py-10 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div
              dangerouslySetInnerHTML={{
                __html: lookUpCMSData?.["Terms And Conditions"]?.Template,
              }}
            />
            {/* <div>
              <div className="mb-12 text-center">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  Hotel Policy & Booking Conditions
                </h1>
              </div>
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-red-700 mb-4">
                  Hotel Policy & Booking Conditions
                </h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The guest has to carry a valid ID proof at the time of
                      check-in.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The Guest has to carry a copy of the booking voucher at
                      the time of check-in.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The standard check-in time is 13:30 PM and the standard
                      check-out time is 10:30 AM.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      Meals included in the package shall be served in the
                      restaurant on buffet or TDH Basis. Breakfast Time: 07:30
                      to 09:30 AM, Lunch Time: 12:30 to 02:30 PM & Hi tea Time:
                      04:30 to 05:30 PM & Dinner Time: 07:30 to 09:30 PM (IST).
                    </span>
                  </li>
                </ul>
              </div>
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-red-700 mb-4">
                  Cancellation Policy
                </h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      100 percent cancellation charges will be levied if
                      cancelled after check-in date or on No show
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      100 percent cancellation charges will be levied if
                      cancelled in between 21 day(s) before check-in date and
                      before on check-in date.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The above cancellation policy is not valid during long
                      weekends, festivals & New Year period and during certain
                      other times of the year wherein rooms will be confirmed
                      subject to non-refundable advance.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-red-700 mb-4">
                  Booking Conditions
                </h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      In case of an early departure, retention charges
                      equivalent to the balance unutilized room nights will be
                      levied and no amount will be refunded or carried forward
                      by the Hotel.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      In case of NO SHOW, retention charges equivalent to total
                      room nights booked, will be charged. Any cancellation or
                      no show will not be allowed fee waiver on the day of
                      check-in
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The Hotel reserves the right to release guaranteed and
                      non-guaranteed reservations with prior information,
                      without any liabilities. We reserve the right to cancel or
                      modify reservations where it appears that a customer has
                      engaged in fraudulent or inappropriate activity or under
                      other circumstances where it appears that the reservations
                      contain or resulted from a mistake or error.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-red-700 mb-4">
                  Cancellations Policy (Additional)
                </h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      No cancellation charges are applicable in case cancelled
                      in between 30 to 21 days prior to the arrival date.
                      However Bank/payment gateway charges will be applicable in
                      case of any refund.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      50% Cancellation charges or future date extensions/Credit
                      note for cancellation request received in between 21 to 15
                      days prior to arrival. The advance deposited amount will
                      be carried forward by the hotel & no refund will be
                      proceeding in case of future date extension.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      In case of No show or cancelled within the 15 days of
                      arrival, retention will be charged equivalent for full
                      stay and no amount will be refunded or carried forward by
                      hotels.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      No Cancellation or amendment is allowed within 15 days
                      prior to arrival.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The reservation stands non refundable and non amendable
                      during long weekends, festivals, Christmas/New Year period
                      (Blackout dates – 20th December to 02nd January) and high
                      demand Dates – Diwali and Dussehra Period (1st to 9th Oct
                      and 22nd to 30th Oct'22).
                    </span>
                  </li>
                </ul>
              </div>
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-red-700 mb-4">
                  Refund Policy
                </h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>Policy will be applicable as per the Rate Plan.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      In case of an early departure, retention charges
                      equivalent to the balance unutilized room nights will be
                      levied and no amount will be refunded or carried forward
                      by the Hotel.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      In case of NO SHOW, retention charges equivalent to total
                      room nights booked, will be charged.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The Hotel reserves the right to release guaranteed and
                      non-guaranteed reservations with prior information,
                      without any liabilities.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gray-500 mr-2">•</span>
                    <span>
                      The refund is processed within 07-10 working days and is
                      re-sent via the same payment mode that was used for making
                      the payment – credit card/bank account.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="mt-12 pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-500 text-center">
                  For any queries regarding these policies, please contact our
                  customer support.
                </p>
              </div>
            </div> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
